import { render, staticRenderFns } from "./RoomType.vue?vue&type=template&id=8e3bcac0&scoped=true&"
import script from "./RoomType.vue?vue&type=script&lang=js&"
export * from "./RoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3bcac0",
  null
  
)

export default component.exports